import { Fragment, useState } from "react";
import { _, dayjs } from "@sablier/v2-mixins";
import { useModalMomentPicker } from "~/client/hooks";
import Content from "../Content";
import Footer from "../Footer";

function MomentPicker() {
  const { data } = useModalMomentPicker();
  const moment = useState<string | undefined>(
    (_.isNilOrEmptyString(data.milliseconds)
      ? dayjs()
      : _.toDayjs(data.milliseconds)
    )
      .second(0)
      .millisecond(0)
      .valueOf()
      .toString(),
  );

  return (
    <Fragment>
      <Content moment={moment} />
      <Footer moment={moment} />
    </Fragment>
  );
}

export default MomentPicker;
